import PropTypes from 'prop-types'

// Internal components
import Svg from '@/components/Svg/Svg'
import PlayerTimer from '@/components/PlayerTimer/PlayerTimer'
import { useMatchLog } from '@/root/context/MatchContext'

const Player = (props) => {
  const { modifiers, type, player, index, setSelectedSpot } = props

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  const { match, setSelectedPlayer, selectedPlayer, showSidebar, setShowSidebar } = useMatchLog()

  const matchDuration = match?.team?.[0]?.ageGroup?.[0]?.matchDuration

  const changePlayer = (e, player) => {
    setSelectedPlayer(player)
    if (!showSidebar) setShowSidebar(true)
  }

  const setClickEvent = (e) => {
    if (type === 'timer') {
      return changePlayer(e, player)
    } else if (type === 'add' || type === 'change') {
      setSelectedSpot(index)
    } else {
      return null
    }
  }

  return (
    <div
      className={`Player ${modifierClasses} ${index === 0 ? 'Player--keeper' : ''} ${
        selectedPlayer?.uuid === player?.uuid && selectedPlayer ? 'Player-stroke' : ''
      }`}
      onClick={(e) => setClickEvent(e)}
    >
      <div className="Player-inner">
        <Svg id={`icon-${index === 0 ? 'keepershirt' : 'playershirt'}`} />
        <div className="Player-shirtContent">
          {type === 'timer' &&
            (selectedPlayer?.uuid === player.uuid ? (
              <Svg id="icon-substitute" modifiers={['Player-substitute']} />
            ) : (
              <PlayerTimer player={player} matchLength={matchDuration} />
            ))}
          {type === 'add' && <Svg id="icon-add" modifiers={['Player-add']} />}
          {type === 'change' && <Svg id="icon-substitute" modifiers={['Player-substitute']} />}
        </div>
        {player.name && (
          <span className={`Player-name ${player.name.length > 8 ? 'Player-longName' : ''}`}>
            {player.name.slice(0, 8)}
            {player.name.length > 8 ? <span className="Player-ellipsis">&hellip;</span> : ''}
          </span>
        )}
      </div>
    </div>
  )
}
Player.defaultPropTypes = {
  modifiers: [],
  type: '',
  player: {},
  index: 0,
  setSelectedSpot: () => {},
  position: ''
}

Player.propTypes = {
  modifiers: PropTypes.array,
  type: PropTypes.string,
  player: PropTypes.object,
  index: PropTypes.number,
  setSelectedSpot: PropTypes.func,
  position: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default Player
